import React, { useCallback } from 'react';
import SearchPicker, { PickerOption } from '../pettyCash/SearchPicker';
import e2iApi from '../../services/e2iApi';
import type { DocMode } from '../../types/e2i';

interface Props {
  id: string;
  companyId: number;
  docMode: DocMode;
  value: string | null;
  onChange: (code: string | null) => void;
  disabled?: boolean;
  helperText?: React.ReactNode;
}

/** What a line posts to in SAP: a sales item (document mode Item) or a revenue account (mode Service). */
const LineItemPicker: React.FC<Props> = ({ id, companyId, docMode, value, onChange, disabled, helperText }) => {
  const search = useCallback(async (q: string): Promise<PickerOption[]> => {
    const rows = docMode === 'Service' ? await e2iApi.accounts(companyId, q) : await e2iApi.items(companyId, q);
    return rows.map((r) => ({ code: r.code, name: r.name }));
  }, [companyId, docMode]);

  return (
    <SearchPicker
      id={id}
      label={docMode === 'Service' ? 'Revenue account (optional)' : 'Sales item (optional)'}
      value={value ? { code: value, name: '' } : null}
      onChange={(o) => onChange(o?.code || null)}
      search={search}
      disabled={disabled}
      helperText={helperText ?? (docMode === 'Service' ? "Empty: the job type's account, else the company default" : "Empty: the job type's sales item, else the company default")}
    />
  );
};

export default LineItemPicker;
